import React from "react";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";
import MUICashTableHeader from "./Headers/CashTableHeader";
import CashGameTableBody from "./Bodys/CashGameTableBody";
import { RootState, GameData, GamelistModalDetails } from "types";


interface PublicCashTableProps {
  setModalDets: (dets: GamelistModalDetails) => void;
  setGameData: (data: GameData) => void;
}

const PublicCashTable = (props: PublicCashTableProps) => {
  const pubCashList = useSelector((state: RootState) => state.games.publicCashList);

  // Show loading indicator if data is not available
  if (!pubCashList) {
    return <CircularProgress />;
  }

  // Check if there are games available
  const gameKeys = Object.keys(pubCashList);
  if (gameKeys.length === 0) {
    return <div>No Public Cash Games Found</div>;
  }

  // Cast to GameData since we know from Redux state that this is the correct type
  const gameData = pubCashList as Record<string, GameData>;

  return (
    <TableContainer component={Paper} elevation={10}>
      <Table className="tablelist" aria-label="public cash table">
        <MUICashTableHeader />
        <CashGameTableBody data={gameData} {...props} />
      </Table>
    </TableContainer>
  );
};

export default PublicCashTable;
